module.exports = __webpack_public_path__ + "img/regnr-2022.9f5002ac.svg";